module.exports = __webpack_public_path__ + "static/img/mb-07.02f6619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x3/mb-07.jpg
// module id = e3Tt
// module chunks = 1